import { cn } from "@disasterscience/scaffoldy";
import { ReactNode, useEffect, useState } from "react";
import { BfMapMarkerType } from "../lib/api/models";
import { KNOWN_MARKERS, MarkerDef, MarkerOutlineVariant, uiMarkers } from "../lib/markers";

type MarkerImageProps = {
    marker?: BfMapMarkerType | null;
    height?: number;
    className?: string;
    children?: ReactNode;
    src?: string;
    /** Render an outlined variant: "auto" (purple, automated origin) or "predicted" (pink); true means "auto" */
    outlined?: boolean | MarkerOutlineVariant;
};

export const MarkerImage = (props: MarkerImageProps) => {
    const [marker, setMarker] = useState<MarkerDef | null>(null);
    const [outlinedSrc, setOutlinedSrc] = useState<string | null>(null);

    useEffect(() => {
        if (props.marker && props.marker in KNOWN_MARKERS && KNOWN_MARKERS[props.marker].payload) {
            setMarker(KNOWN_MARKERS[props.marker]);
        }
    }, [props.marker]);

    useEffect(() => {
        if (!props.outlined || !props.marker || !(props.marker in KNOWN_MARKERS)) {
            setOutlinedSrc(null);
            return;
        }

        const variant = props.outlined === true ? "auto" : props.outlined;

        let active = true;
        uiMarkers()
            ?.outlinedDataUrl(props.marker, variant)
            .then((url) => {
                if (active) setOutlinedSrc(url);
            });

        return () => {
            active = false;
        };
    }, [props.marker, props.outlined]);

    const height = props.height ? props.height : undefined;

    if (marker) {
        return (
            <>
                <img
                    src={outlinedSrc ?? marker.payload}
                    alt={props.marker || undefined}
                    title={props.marker || undefined}
                    className={cn(
                        "tw:w-10 tw:pe-1",
                        props.marker === BfMapMarkerType.roadHazard ||
                            props.marker === BfMapMarkerType.roadClosed
                            ? "tw:w-7 tw:p-2"
                            : "",
                        props.className
                    )}
                    height={height}
                />
                {props.children}
            </>
        );
    } else {
        if (props.src) {
            return (
                <>
                    <img
                        src={props.src}
                        alt={props.marker || undefined}
                        title={props.marker || undefined}
                        className={cn("tw:w-10 tw:pe-1", props.className)}
                        height={height}
                    />
                    {props.children}
                </>
            );
        }
        return <>{props.children}</>;
    }
};
